export default class Navigation {
  constructor(dom) {
    this.dom = dom;
    this.updateNavHeightCssVar();
    this.initHamBtn();
    this.initDekstopMenu();
    this.desktopOverlayControl();
    window.addEventListener("resize", () => this.resize());
  }

  setHideOnScroll() {
    this.hidden = false;
    this.oldTop = window.scrollY;
    window.addEventListener("scroll", () => {
      let currTop = window.scrollY;
      if (currTop > this.oldTop + 10 && this.hidden == false) {
        this.hideElement();
      } else if (currTop < this.oldTop - 5 && this.hidden == true) {
        this.showElement();
      }
      this.oldTop = currTop;
    });
  }

  hideElement() {
    this.dom.classList.add("shy");
    this.hidden = true;
  }

  showElement() {
    this.dom.classList.remove("shy");
    this.hidden = false;
  }

  updateNavHeightCssVar() {
    document.body.style.setProperty(
      "--navHeight",
      `${document.querySelector('.prom-bar') ? this.dom.clientHeight - document.querySelector('.prom-bar').clientHeight : this.dom.clientHeight}px`
    );

    document.body.style.setProperty(
      "--promBarHeight",
      `${document.querySelector('.prom-bar') ? document.querySelector('.prom-bar').clientHeight : 0}px`
    );
  }

  initHamBtn() {
    let btn = this.dom.querySelector("[js-ham-btn]");
    // console.log(btn);
    let menu = this.dom.querySelector("[js-m-menu-overlay]");
    let close = this.dom.querySelector("[js-m-menu-close]");
    btn.addEventListener("click", () => {
      // console.log("click");
      menu.classList.add("opened");
      document.querySelector('body').classList.add('opened');

    });
    close.addEventListener("click", () => {
      // console.log("unclick");
      menu.classList.remove("opened");
      document.querySelector('body').classList.remove('opened');
    });
  }

  initDekstopMenu() {
    let menuItems = this.dom.querySelectorAll(".menu--item");

    for (let item of menuItems) {
      let targetItem = item.querySelector(".menu--item__target");

      targetItem.addEventListener("mouseenter", (e) => {
        // console.log("enter");
        let allOverlay = this.dom.querySelectorAll(".menu-sub-overlay");
        let overlay = item.querySelector(".menu-sub-overlay");

        for (let ovItem of allOverlay) {
          let ov;
          if (overlay) {
            ov && ov.classList.remove("show");
            ov = ovItem;
            ovItem.classList.remove("show");

            overlay.classList.add("show");
            overlay.addEventListener("click", (e) => {
              if (e.target.tagName.toLowerCase() === "a") {
                e.target.href; //this is the url where the anchor tag points to.
              } else {
                setTimeout((e) => {
                  overlay.classList.remove("show");
                  this.resetMenu();
                }, 100);
              }
            });
            overlay.addEventListener("mouseleave", (e) => {
              ovItem.classList.remove("show");
              this.resetMenu();
            });
          } else {
            ovItem.classList.remove("show");
            this.resetMenu();
            let layer1Items = this.dom.querySelectorAll(".menu-layer1--item");
            for (let item of layer1Items) {
              item.classList.remove("selected");
            }
          }
        }
        // console.log(overlay);
      });
    }
  }

  desktopOverlayControl() {
    let layer1Items = this.dom.querySelectorAll(".menu-layer1--item");
    let layer2List = this.dom.querySelectorAll(".menu-layer2--list");

    let selectedEl;

    let triggerVal;
    let linkedVal;

    for (let item1 of layer1Items) {
      item1.addEventListener("mouseenter", (e) => {
        selectedEl && selectedEl.classList.remove("selected");
        selectedEl = item1;
        item1.classList.add("selected");

        triggerVal = e.target.dataset.target;
        // console.log(triggerVal);
        for (let target2List of layer2List) {
          linkedVal = target2List.dataset.target;

          if (linkedVal === triggerVal) {
            target2List.classList.add("visible");
          } else {
            target2List.classList.remove("visible");
          }
        }

        // remove lv2 selected
        let layer2Items = this.dom.querySelectorAll(".menu-layer2--item");
        for (let item2 of layer2Items) {
          item2.classList.remove("selected");
        }

        // remove lv3 items
        let layer3Lists = this.dom.querySelectorAll(".menu-layer3--list");
        for (let l3 of layer3Lists) {
          l3.classList.remove("visible");
        }
      });
    }

    //
    let layer2Items = this.dom.querySelectorAll(".menu-layer2--item");
    let layer3Lists = this.dom.querySelectorAll(".menu-layer3--list");

    let layer2SelectedEl;

    let laye2TriggerVal;
    let layer3LinkedVal;

    for (let item2 of layer2Items) {
      item2.addEventListener("mouseenter", (e) => {
        layer2SelectedEl && layer2SelectedEl.classList.remove("selected");
        layer2SelectedEl = item2;
        item2.classList.add("selected");

        laye2TriggerVal = e.target.dataset.l3target;
        // console.log(laye2TriggerVal);
        for (let layer3 of layer3Lists) {
          layer3LinkedVal = layer3.dataset.content;

          if (layer3LinkedVal === laye2TriggerVal) {
            layer3.classList.add("visible");
          } else {
            layer3.classList.remove("visible");
          }
        }
      });
    }
  }

  resetMenu() {
    let layer2List = this.dom.querySelectorAll(".menu-layer2--list");
    for (let list2 of layer2List) {
      list2.classList.remove("visible");
    }
    let layer3Lists = this.dom.querySelectorAll(".menu-layer3--list");
    for (let list3 of layer3Lists) {
      list3.classList.remove("visible");
    }
  }

  resize() {
    this.updateNavHeightCssVar();
    // console.log("resize from Navigation.js");
  }
}
